import { ModalidadPrestacion } from './modalidadPrestacion';

export class ClaseModalidad {
	id: 'IN' | 'TF' | 'TU' | 'CI' | 'TA' | 'TI';
	descripcion: string;
	modalidadesPrestacion: Array<ModalidadPrestacion>;

	constructor(data = null) {
		if (data) {
			this.id = data.id;
			this.descripcion = data.descripcion;
			this.modalidadesPrestacion = data.modalidadesPrestacion;
		}
	}
}
